var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3659 11.7778H23.5565C20.5233 11.7778 18 14.3003 18 17.4127V45.5873C18 48.6997 20.5225 51.2222 23.5557 51.2222H57.3651C60.4775 51.2222 63 48.6997 63 45.5873V17.4127C63.0008 14.3003 60.5531 11.7778 57.3659 11.7778ZM58.7746 44.9974L46.73 28.6297C46.5099 28.2247 46.008 27.9782 45.471 27.9782C44.9327 27.9782 44.4303 28.2219 44.1318 28.6279L34.7462 41.3152L31.4805 37.2563C31.1776 36.8796 30.694 36.6568 30.1801 36.6568C29.6658 36.6568 29.1826 36.8795 28.8788 37.2563L22.2296 45.5159C22.2296 45.5184 22.2296 45.5133 22.2296 45.5159L22.2261 17.4127C22.2261 16.636 22.8581 16.004 23.6348 16.004H57.4443C58.221 16.004 58.853 16.636 58.853 17.4127V44.9974H58.7746Z",
    fill: "#E6EAEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3836 19.5259C29.0496 19.5259 27.1575 21.418 27.1575 23.7521C27.1575 26.0861 29.0496 27.9782 31.3836 27.9782C33.7177 27.9782 35.6098 26.0861 35.6098 23.7521C35.6098 21.418 33.7169 19.5259 31.3836 19.5259Z",
    fill: "#80959B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.f93813a4a7a56941519d7129a174f961.svg";
export { ForwardRef as ReactComponent };